(ns machtfit.stepchall.my-steps
  (:require [machtfit.format :as format]
            [machtfit.startpage.api-events :as api-events]
            [machtfit.stepchall.activity-log :as activity-log]
            [machtfit.stepchall.charts :as charts]
            [machtfit.stepchall.subs :as subs]
            [machtfit.translation :refer [t str-tr]]
            [re-frame.core :as rf]))

(rf/reg-event-fx ::navigate-to-stepchall-my-steps
  (fn [{:keys [db]} _]
    (-> {:db (assoc-in db [:ui :page] {:id :stepchall
                                       :subpage :my-steps})}
        (assoc :scroll-to {:frame :app-frame
                           :mode :page-top})
        (api-events/api-requests-on-stepchall-event))))

(defn ^:private secs->days [secs]
  (/ secs 60 60 24))

(rf/reg-sub ::elapsed-days
  :<- [:get [:stepchall :challenge-start]]
  :<- [:get [:server-info :reference-now]]

  (fn [[challenge-date-start today] _]
    (-> (- today challenge-date-start)
        secs->days
        int
        inc)))

(rf/reg-sub ::step-count-average
  :<- [:get [:stepchall :participant :step-counts :total]]
  :<- [::elapsed-days]

  (fn [[total-steps current-day-count] _]
    (int (/ total-steps current-day-count))))

(defn my-steps []
  (let [main-unit-plural @(rf/subscribe [:get [:stepchall :main-unit :plural]])]
    [:div
     [:div.sc_content
      [:div.sc_vertical-center.sc_justify-center
       [:h2.sc_headline
        (t (str-tr {:de "Meine " :en "My "} main-unit-plural))]]
      [:div.sc_subtitle
       (str (format/decimal @(rf/subscribe [:get [:stepchall :participant :step-counts :total]]))
            " / "
            (format/decimal @(rf/subscribe [:get [:stepchall :goal]]))) " " (t main-unit-plural)]
      (when @(rf/subscribe [::subs/challenge-started?])
        [:div.sc_subtitle
         "Ø "
         (format/decimal @(rf/subscribe [::step-count-average]))
         " "
         (t (str-tr {:de "" :en "Daily "} main-unit-plural {:de " pro Tag" :en ""}))])

      [:div.sc_my-steps
       [charts/charts-container]
       [activity-log/activity-log]]]]))
